import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function Forbidden() {
  const { firebaseUser, signOut } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full text-center">
        <h1 className="text-2xl font-semibold text-slate-800 mb-2">Access denied</h1>
        <p className="text-slate-600 mb-6">
          You don&apos;t have admin privileges. Only users with the admin role can use this portal.
        </p>
        <div className="flex flex-col gap-3">
          {firebaseUser ? (
            <button
              onClick={() => signOut()}
              className="rounded-lg border border-slate-300 px-4 py-2 text-slate-700 hover:bg-slate-50"
            >
              Sign out
            </button>
          ) : (
            <Link
              to="/login"
              className="rounded-lg bg-indigo-600 text-white px-4 py-2 font-medium hover:bg-indigo-700 inline-block"
            >
              Sign in
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
